module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "radio blu-radio",
    class: [{
      'on': _vm.isChecked
    }, _vm.typeClass, {
      'is-disabled': _vm.disabled
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    ref: "checkbox",
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.isChecked,
      "value": _vm.val,
      "checked": _vm._q(_vm.model, _vm.val)
    },
    on: {
      "change": function($event) {
        _vm.model = _vm.val
      }
    }
  }), _vm._v(" "), _c('span', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-875563ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio/Radio.vue
// module id = 351
// module chunks = 0